export default {"src":"/_next/static/media/404ErrorDark.b8bee37d.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};